import { currentPage } from '../common/layout';
import { formsConfig as forms } from '../common/forms';
// import 'jquery';
import 'jquery-form';
import 'jquery-validation';
import { formsConfig } from '../common/forms';
import { formValidateConfig } from '../common/jquery-validate-config';
import { getCookie } from '../common/utils/fn';

currentPage.pageInit = ($page, pageData, pageId) => {
  formValidateConfig.init({
    forms: formsConfig,
  });

  var cpAuthhint = document.cookie.includes('_cpauthhint=1');
  const inputScreenResolution = document.querySelector('input[name="screen"]');
  if (inputScreenResolution) {
    inputScreenResolution.value = `${window.innerWidth}x${window.innerHeight}`;
  }

  if (!cpAuthhint) {
    $('#submitbutton').on('click', function (e) {
        e.preventDefault();
        if (typeof grecaptcha !== 'undefined') {
          grecaptcha.ready(function() {
              grecaptcha.execute('6LcFI2wpAAAAAE_ID29Oc5L_WJtsfNRiyNVT2PMZ', {
                  action: 'submit',
              }).then(function(token) {
                if(token){
                  const gResponseInput = document.getElementById('g-recaptcha-response');
                  if (gResponseInput) gResponseInput.value = token;
                  $('#feedback_form').submit();
                }
              });
          });
      }
    });
  }
  $('#feedback_form').validate();
};
